module.exports = __webpack_public_path__ + "img/ad6d451.png";